'use client';

import { useRouter } from 'next/navigation';

import PointCard from '@/app/(football)/[team]/_components/common/PointCard';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import { useCurrentPath } from '@/hooks/useCurrentPath';
import { useAppSelector } from '@/store/client/config';
import { useGetMyPointQuery } from '@/store/server/common/point/point.query';

export default function MyPointCard() {
  const router = useRouter();
  const currentPath = useCurrentPath();
  const { teamSlug } = useTeamConfig();
  const isLoggedIn = useAppSelector((state) => state.user.LoggedIn);
  const { data: myPoint } = useGetMyPointQuery();

  const formattedPoint = myPoint?.point.toLocaleString('ko-KR').concat('P') ?? '-';

  const handleClick = () => {
    if (isLoggedIn) {
      router.push(`/mypage/point?return_originals_url=${currentPath}`);
      return;
    }
    router.push(`/account/login?retUrl=${currentPath}`);
  };

  return (
    <PointCard
      teamSlug={teamSlug}
      label="보유 포인트"
      value={isLoggedIn ? formattedPoint : '-'}
      onClick={handleClick}
    />
  );
}
